import type { Abogado, Audiencia, Expediente, Plazo } from '../types'
import { diasRestantes } from './fechas'
import { plazosVigentes } from './consultas'

export const LIMITE_EXPEDIENTES = 8
export const LIMITE_CRITICOS = 3

export interface CargaAbogado {
  abogado: Abogado
  expedientes: Expediente[]
  activos: number
  plazos: Plazo[]
  criticos: number
  audiencias: Audiencia[]
  sobrecargado: boolean
}

export function cargaDe(
  abogado: Abogado,
  expedientes: Expediente[],
  plazos: Plazo[],
  audiencias: Audiencia[] = [],
): CargaAbogado {
  const asignados = expedientes.filter((e) => e.abogadoIds.includes(abogado.id))
  const susPlazos = plazosVigentes(plazos).filter((p) => p.responsableId === abogado.id)
  const criticos = susPlazos.filter((p) => diasRestantes(p.fechaLimite) <= 3).length
  const activos = asignados.filter((e) => e.estado === 'Activo').length
  return {
    abogado,
    expedientes: asignados,
    activos,
    plazos: susPlazos,
    criticos,
    audiencias: audiencias
      .filter((a) => a.abogadoId === abogado.id && diasRestantes(a.fecha) >= 0)
      .sort((a, b) => (a.fecha < b.fecha ? -1 : 1)),
    sobrecargado: activos > LIMITE_EXPEDIENTES || criticos >= LIMITE_CRITICOS,
  }
}

export function puedeRecibirExpedientes(abogado: Abogado): boolean {
  return abogado.activo && abogado.rol !== 'Recepción/Archivo'
}
